import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-4",
    style: {"font-size":"1rem"}
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Đơn vị: ..........................................."),
    /*#__PURE__*/_createElementVNode("p", null, "Bộ phận: ...........................................")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4" }),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4 d-flex flex-column align-items-center" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-nowrap mb-0" }, " Mẫu số 02-VT "),
    /*#__PURE__*/_createElementVNode("p", { class: "text-nowrap mb-0" }, " (Ban hành theo QĐ số: 200/2014/TT-BTC "),
    /*#__PURE__*/_createElementVNode("p", { class: "text-nowrap mb-0" }, " Ngày 22/12/2014 của Bộ trưởng BTC) ")
  ])
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1)
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bolder" }, " PHIẾU XUẤT KHO ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-center mb-0" }, " Ngày ...... tháng ...... năm ...... ", -1)
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "fw-bolder" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-4",
  style: {"padding-top":"2rem"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex mb-3",
    style: {"font-size":"1rem"}
  }, [
    /*#__PURE__*/_createElementVNode("p", {
      class: "text-end mb-0 w-25",
      style: {"width":"40%"}
    }, "TK ghi nợ:"),
    /*#__PURE__*/_createElementVNode("p", {
      class: "ps-1 mb-0 w-75",
      style: {"border-bottom":"dashed 0.8px #383434"}
    }, [
      /*#__PURE__*/_createElementVNode("strong")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex",
    style: {"font-size":"1rem"}
  }, [
    /*#__PURE__*/_createElementVNode("p", {
      class: "text-end mb-0 w-25",
      style: {"width":"40%"}
    }, "TK ghi có:"),
    /*#__PURE__*/_createElementVNode("p", {
      class: "ps-1 mb-0 w-75",
      style: {"border-bottom":"dashed 0.8px #383434"}
    }, [
      /*#__PURE__*/_createElementVNode("strong")
    ])
  ])
], -1)
const _hoisted_11 = { class: "row mt-5" }
const _hoisted_12 = { style: {"word-break":"break-word !important"} }
const _hoisted_13 = { class: "fw-bolder me-5" }
const _hoisted_14 = { style: {"word-break":"break-word !important"} }
const _hoisted_15 = { class: "fw-bolder me-2" }
const _hoisted_16 = { class: "fw-bolder me-3" }
const _hoisted_17 = { style: {"word-break":"break-word !important"} }
const _hoisted_18 = { class: "fw-bolder me-5" }
const _hoisted_19 = {
  key: 0,
  style: {"word-break":"break-word !important"}
}
const _hoisted_20 = { class: "fw-bolder me-5" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { style: {"width":"100%"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    width: "40",
    class: "text-start break-word"
  }, "TT"),
  /*#__PURE__*/_createElementVNode("th", { class: "break-word text-start" }, "Tên, nhãn hiệu, quy cách, phẩm chất vật tư, dụng cụ sản phẩm, hàng hóa "),
  /*#__PURE__*/_createElementVNode("th", {
    width: "90",
    class: "text-start break-word"
  }, "Mã số"),
  /*#__PURE__*/_createElementVNode("th", {
    width: "70",
    class: "text-start break-word"
  }, "ĐVT"),
  /*#__PURE__*/_createElementVNode("th", {
    width: "90",
    class: "text-start break-word"
  }, "Số lượng"),
  /*#__PURE__*/_createElementVNode("th", {
    width: "100",
    class: "text-start break-word"
  }, "Đơn giá"),
  /*#__PURE__*/_createElementVNode("th", {
    width: "100",
    class: "text-start break-word"
  }, "Thành tiền")
], -1)
const _hoisted_25 = { class: "text-start" }
const _hoisted_26 = { class: "text-start" }
const _hoisted_27 = { class: "text-start" }
const _hoisted_28 = { class: "text-start" }
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tổng cộng")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_38 = { class: "text-end" }
const _hoisted_39 = {
  class: "text-end mt-2 mb-4",
  style: {"word-break":"break-word !important"}
}
const _hoisted_40 = { class: "d-flex justify-content-between" }

import {
  computed,
  getCurrentInstance,
  PropType,
  ref,
  watch,
} from 'vue';
import {ReceiptBaseResponse} from '../../../../../core/interfaces/ApiResponses';
import {formatCurrencyAndQuantity} from '../../../../../core/helpers/utils';
import {useButtonCustom} from '../../../../../core/hooks/use-button-custom';
import {useDateTime} from '../../../../../core/hooks/use-date-time-hook';
import ButtonCustom from '../../../../../components/shared/buttons/ButtonCustom.vue';
import DivCol from '../../../../../layout/_shared/DivCol.vue';
import DivRow from '../../../../../layout/_shared/DivRow.vue';
import SignatureCol from '../../../../../layout/_shared/SignatureCol.vue';
import ToolService from '../../../../../core/services/Tool.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhieuXuatKhoPrintModal',
  props: {
  phieuXuatKhoDetail: {
    type: Object as PropType<ReceiptBaseResponse>,
    required: true,
  }
},
  emits: ['on-close-modal'],
  setup(__props, { expose: __expose, emit: __emit }) {

const app = getCurrentInstance();

const props = __props;

const {ButtonsType} = useButtonCustom();
const {formatDisplayingDate} = useDateTime();

const modalId = ref('phieu-xuatkho-print-modal');
const isOpen = ref(false);
const tongTienInText = ref('');

watch(
    () => props.phieuXuatKhoDetail,
    async () => {
      let total = 0;

      props.phieuXuatKhoDetail.vat_tu_xuat_kho.forEach(({pivot: {don_gia}, pivot: {so_luong}}) => {
        total += +so_luong * +(don_gia ?? 0)

      });
      total = Math.round(total);

      const {
        data: {data},
      } = await ToolService.convertPriceToText(total);

      tongTienInText.value = data;
    }
)
const emit = __emit;

const totalPrice = computed(() => {
  let result = 0;

  props.phieuXuatKhoDetail.vat_tu_xuat_kho.forEach(({don_gia: don_gia_goc, pivot: {so_luong, don_gia}}) => {
    result += +so_luong * +(don_gia ?? 0)
  });

  return result;
});

const onClose = () => {
  emit('on-close-modal');
}

const onPrintingButtonClicked = () => {
  (app.appContext.config.globalProperties as any).$htmlToPaper(modalId.value);
}

__expose({
  isOpen,
});

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    width: "80%",
    title: "Phiếu xuất kho",
    onClose: onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        id: modalId.value,
        class: "printing-paper"
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, [
              _createTextVNode(" Phiếu xuất kho số: "),
              _createElementVNode("span", _hoisted_9, _toDisplayString(__props.phieuXuatKhoDetail.so_phieu), 1)
            ])
          ]),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, [
            _createTextVNode("- Họ, tên người nhận hàng: "),
            _createElementVNode("span", _hoisted_13, _toDisplayString(__props.phieuXuatKhoDetail.nguoi_nhan?.ho_va_ten), 1),
            _createTextVNode(" Địa chỉ (bộ phận): ..................................................")
          ]),
          _createElementVNode("p", _hoisted_14, [
            _createTextVNode(" - Lý do xuất kho: "),
            _createElementVNode("span", _hoisted_15, _toDisplayString(__props.phieuXuatKhoDetail.ly_do || '.....................................................'), 1),
            _createTextVNode(" Theo biên bản số: "),
            _createElementVNode("span", _hoisted_16, _toDisplayString(__props.phieuXuatKhoDetail.bien_ban_giai_the?.so_bien_ban || '....................'), 1),
            _createTextVNode(" Ngày: ............................. ")
          ]),
          _createElementVNode("p", _hoisted_17, [
            _createTextVNode(" - Xuất tại kho: "),
            _createElementVNode("span", _hoisted_18, _toDisplayString(__props.phieuXuatKhoDetail.kho?.ten_kho), 1)
          ]),
          (__props.phieuXuatKhoDetail.ngay_hoan_thanh)
            ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                _createTextVNode(" - Ngày hoàn thành: "),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(formatDisplayingDate)(__props.phieuXuatKhoDetail.ngay_hoan_thanh)), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("table", _hoisted_23, [
              _hoisted_24,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.phieuXuatKhoDetail.vat_tu_xuat_kho, (vatTu, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: vatTu.id
                }, [
                  _createElementVNode("td", _hoisted_25, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(vatTu.ten_vat_tu), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(vatTu.ma_vat_tu), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(vatTu.don_vi_tinh), 1),
                  _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(formatCurrencyAndQuantity)(vatTu.pivot.so_luong)), 1),
                  _createElementVNode("td", _hoisted_30, _toDisplayString(_unref(formatCurrencyAndQuantity)(+vatTu.pivot?.don_gia ?? 0)), 1),
                  _createElementVNode("td", _hoisted_31, [
                    _createElementVNode("strong", null, _toDisplayString(_unref(formatCurrencyAndQuantity)(Math.round(+(vatTu.pivot.don_gia ?? 0) * +vatTu.pivot.so_luong), false)), 1)
                  ])
                ]))
              }), 128)),
              _createElementVNode("tr", null, [
                _hoisted_32,
                _hoisted_33,
                _hoisted_34,
                _hoisted_35,
                _hoisted_36,
                _hoisted_37,
                _createElementVNode("td", _hoisted_38, [
                  _createElementVNode("strong", null, _toDisplayString(_unref(formatCurrencyAndQuantity)(Math.round(totalPrice.value), false)), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createTextVNode(" Tổng số tiền (viết bằng chữ): "),
          _createElementVNode("strong", null, _toDisplayString(tongTienInText.value), 1)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", null, [
            _createVNode(SignatureCol, { "nguoi-ky": "Người nhận hàng" })
          ]),
          _createElementVNode("div", null, [
            _createVNode(SignatureCol, { "nguoi-ky": "P.Kế hoạch vật tư" })
          ]),
          _createElementVNode("div", null, [
            _createVNode(SignatureCol, { "nguoi-ky": "Thủ kho" })
          ]),
          _createElementVNode("div", null, [
            _createVNode(SignatureCol, { "nguoi-ky": "P.Tài chính" })
          ]),
          _createElementVNode("div", null, [
            _createVNode(SignatureCol, { "nguoi-ky": "Giám đốc" })
          ])
        ])
      ], 8, _hoisted_1),
      _createVNode(DivRow, { class: "mt-5" }, {
        default: _withCtx(() => [
          _createVNode(DivCol, { cols: 10 }),
          _createVNode(DivCol, {
            cols: 2,
            class: "text-end"
          }, {
            default: _withCtx(() => [
              _createVNode(ButtonCustom, {
                "button-type": _unref(ButtonsType).FA_PRINT,
                onClick: onPrintingButtonClicked
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("In phiếu")
                ]),
                _: 1
              }, 8, ["button-type"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})